import { useContext } from "react";

import Button from "~/components/Button/Button";
import Dialog from "~/components/Dialog/Dialog";
import SettingsContext from "~/contexts/SettingsContext";

import styles from "./JoinLoyaltyModal.module.css";
import { useFetcher } from "@remix-run/react";
import { KEYS } from "~/modules/checkout/constants";

interface JoinLoyaltyModalProps {
  visible: boolean;
  onClose: () => void;
}

const JoinLoyaltyModal: React.FC<JoinLoyaltyModalProps> = ({
  visible,
  onClose,
}) => {
  const { orgSettings } = useContext(SettingsContext);

  const fetcher = useFetcher({ key: KEYS.MY_ACCOUNT_FETCHER });

  const onJoin = () => {
    const formData = new FormData();
    formData.append("loyaltyCheckbox", "true");
    formData.append("allowEmail", "true");

    fetcher.submit(formData, {
      method: "POST",
      action: "/auth/myAccount",
    });
  };

  return (
    <Dialog visible={visible} onClose={onClose}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>Join Our Loyalty Programme</h2>
          <p className={styles.subtitle}>
            Earn {orgSettings?.loyaltySettings?.balanceUnitName ?? "points"}{" "}
            with every purchase and get exclusive rewards!
          </p>
        </div>

        <div className={styles.content}>
          <div className={styles.benefits}>
            <div className={styles.benefit}>
              <span className={styles.benefitIcon} />
              <span>
                Earn {orgSettings?.loyaltySettings?.balanceUnitName ?? "points"}{" "}
                on every order
              </span>
            </div>
            <div className={styles.benefit}>
              <span className={styles.benefitIcon}>•</span>
              <span>Exclusive member rewards</span>
            </div>
            <div className={styles.benefit}>
              <span className={styles.benefitIcon}>•</span>
              <span>Special birthday treats</span>
            </div>
          </div>
        </div>

        <div className={styles.footer}>
          <Button
            className={styles.joinButton}
            onClick={onJoin}
            loading={fetcher.state !== "idle"}
          >
            Join Loyalty Programme
          </Button>

          <Button
            variant="secondary"
            className={styles.cancelButton}
            onClick={onClose}
            disabled={fetcher.state !== "idle"}
          >
            Maybe Later
          </Button>
        </div>

        <div className={styles.disclaimer}>
          <p>
            By joining, you agree to receive promotional emails and text
            messages. You can unsubscribe at any time.
          </p>
        </div>
      </div>
    </Dialog>
  );
};

export default JoinLoyaltyModal;
